<template>
  <div element-loading-text="加载中……" v-loading="loading" class="images-list">
    <div class="no-data" v-if="!images || !images.length">
      <span v-if="!loading">暂无数据</span>
    </div>

    <slot
      v-for="(img, index) in images"
      name="img"
      :img="img"
      :index="index"
      :height="height"
    >
      <div class="images-list__item" :key="img.id || index">
        <div class="images-item__wrap" :style="`flex: 0 0 ${split}%;`">
          <el-image :src="img.src || img.tempPath">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { debounce } from '@/utlis'

export default {
  props: {
    images: { type: Array },
    loading: Boolean,
    cols: {
      type: [Number, String],
      default: 7
    }
  },
  data() {
    return {
      height: 200,
      evt: null
    }
  },
  computed: {
    split() {
      return Math.floor(100 / this.cols)
    }
  },
  mounted() {
    this.resize()
    this.evt = debounce(this.resize, 100)
    window.addEventListener('resize', this.evt)
  },
  methods: {
    resize() {
      let width = this.$el.clientWidth
      let imgWidth = Math.max(width / 7 - 16, 200)
      this.height = Math.round(imgWidth * 0.75)
    }
  }
}
</script>

<style lang="scss">
.images-list {
  display: flex;
  flex-wrap: wrap;
  min-height: 600px;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  .images-item__wrap {
    flex: 0 0 14%;
    min-width: 188px;
  }
  .images-list__item {
    padding: 8px;
    .el-card {
      cursor: pointer;
    }
  }
  .images-list__footer {
    font-size: 14px;
    padding: 4px;
    .cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .cell:not(:last-child) {
      margin-bottom: 6px;
    }
  }
  .no-data {
    height: 100%;
  }
}
</style>
